<h2>{{ title }}</h2>
<ng-container *ngIf="rows && rows.length > 0">
    <table>
        <thead>
            <tr>
                <th>Issuer</th>
                <th>Exposure Limit</th>
                <th>Utilized</th>
                <th>Available Margin</th>
                <th>Available Exposure</th>
                <th>Status as of:</th>
                <th>Currency</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of rows" [class.row-total]="row.source === 'Total'">
                <td class="issuer">{{ row.source }}</td>
                <td class="exposure-limit">
                    {{ formatNumber(row.exposureLimit) }}
                </td>
                <td class="utilized">{{ formatNumber(row.utilized) }}</td>
                <td class="available">
                    {{ formatNumber(row.available) }}
                </td>
                <td class="net-margin">
                    {{ formatNumber(row.netMargin) }}
                </td>
                <ng-container *ngIf="row.source !== 'Total'">
                    <td class="status-as-of">
                        {{ row.statusAsOf }}
                    </td>
                    <td class="currency">
                        <div class="arrow-icon" (click)="navigateToCreditPage()">
                            <mat-icon>keyboard_arrow_right</mat-icon>
                        </div>
                        <span>{{ row.currency }}</span>
                    </td>
                </ng-container>
                <ng-container *ngIf="row.source === 'Total'">
                    <td colspan="2"></td>
                </ng-container>
            </tr>
        </tbody>
    </table>
</ng-container>

<ng-container *ngIf="isLoading" #loading>
    <div aria-busy="true" class="table-loading skeleton-loader skeleton-loader-table">
        Loading
    </div>
</ng-container>

<ng-container *ngIf="isNoData && !isError" #noData>
    No credits data for yesterday
</ng-container>

<ng-container *ngIf="isError" #error>No credits data</ng-container>
